import { Component, OnInit, Input } from '@angular/core';
import { LoveHateAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-love-hate',
  templateUrl: './love-hate.component.html',
  styleUrls: ['./love-hate.component.scss']
})
export class LoveHateComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'love-hate';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: LoveHateAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'love-hate',
        title: 'Love & Hate',
        type: 'children',
        childType: 'love-hate',
        plural: 'love / hate items',
        singular: 'Love / Hate Item',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
